import { useUserDetails } from './useUserDetails';

/** @category Logging in and Security */
export function useOwnHandle() {
  return useUserDetails()?.displayHandle;
}
